<template>
    <div class="content mt20">
        <div class="account-content bgfff">
            <dataAnalysisMenu></dataAnalysisMenu>
        </div>
        <div class="account-bd">&nbsp;</div>
        <div class="account-content bgfff" style="position:relative;">
            <div class="one-bd clearfix">
                <div class="fl">
                    <router-link to="/wxdataAnalysis">我的业绩</router-link>
                    <router-link to="/wxdataAnalysis/myFans">我的粉丝</router-link>
                    <router-link to="/wxdataAnalysis/myArticle">我的文章</router-link>
                </div>
                <div class="btn-warp fr">
                    <button class="btn btn-blue" @click="selectPublic"><i class="icons jiaohu-icon"></i>选择其他媒体号</button>
                </div>
            </div>
            <div class="select-public" :class="(Active?'':'hide')" id="ghList">
                <div class="select-warp">
                    <div class="close fr" @click="closeModal"><img src="/static/images/close.png" ></div>
                    <div class="one-bd clearfix">
                        <div class="search fl">
                            <input type="text" v-model="sel" class="input-text" name="search" placeholder="请输入用户名/手机号">
                        </div>
                        <button class="btn btn-blue" @click="searchButton"><i class="icons search-icon"></i></button>
                    </div>
                    <div class="gh-warp clearfix mt20" id="ghWarpList">
                        <div class="img-word" v-for="(item,index) in selectPList" :key="index" @click="clickPublic(item.id)">
                            <img :src="item.headImg" class="img"/>
                            <div class="word">
                                <div class="in">
                                    <span class="name db">{{item.nickname}}</span>
                                    <span class="en-name db">{{item.alias}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="xinxi-header mt30 clearfix">
                <div class="img-word fl">
                    <img :src="wxInfo.headImg" class="img"/>
                    <i class="icons wx-icon"></i>
                    <div class="word">
                        <div class="in">
                            <span class="name">{{wxInfo.nickname}}</span>
                            <span class="en-name">{{wxInfo.alias}}</span>
                        </div>
                    </div>
                </div>
                <div class="rank-item  clearfix fl">
                    <div class="item fl">
                        <span class="rank-num db">{{wxInfo.rank}}</span>
                        <span class="rank-word db">总排名 <span :class="[{'color-red':parseInt(wxInfo.rankUp)>0},{'cr1ab968':parseInt(wxInfo.rankUp)<0},{'color-gray':parseInt(wxInfo.rankUp)==0}]"><i class="icons" :class="parseInt(wxInfo.rankUp)>0 ? ' icon-up1' : ' icon-down1'" v-if="!wxInfo.rankUp==0"></i>{{wxInfo.rankUp}}</span></span>
                    </div>
                </div>
                
            </div>
       </div>
       <div class="account-bd">&nbsp;</div>
       <div class="bgfff">
            <div class="bd clearfix">
                <div class="title fl">{{dateOne}} 业绩分析</div>
                <div class="w194 ml25 form-time fr" v-if="(datetype != 'week'&&datetype !='month')">
                    <vue-datepicker-local v-model="timeRange" format="YYYY-MM-DD" :disabled-date="disabledDate" showButtons  @confirm="selectedDate"/><i class="icons date-icon fr"></i>
                </div>
                <div class="dropdown-toggle w194 ml25 fr" v-if="(datetype == 'week')">
                    <div class="dropdown" >
                        <span >{{dateOne}}</span>
                        <i class="icons icons-down fr"></i>
                    </div>
                    <div class="drop-down w194">
                        <ul class="dropdown-menu dropdown-menu1" role="menu">
                            <li v-for="(item,index) in dateWeek" :key="index">
                                <a class="day" :class="(dateOne==item?'active':'')" @click="dateClick(item)">{{item}}</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="dropdown-toggle w194 ml25 fr" v-if="(datetype == 'month')">
                    <div class="dropdown" >
                        <span >{{dateOne}}</span>
                        <i class="icons icons-down fr"></i>
                    </div>
                    <div class="drop-down w194">
                        <ul class="dropdown-menu dropdown-menu1" role="menu">
                            <li v-for="(item,index) in dateMonth" :key="index">
                                <a class="day" :class="(dateOne==item?'active':'')" @click="dateClick(item)">{{item}}</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="btns-group time-tab fr">
                    <a :class="(datetype != 'week'&&datetype !='month')?'active':''" @click="dateList('day')" href="javascript:void(0);">日榜</a>
                    <a :class="(datetype == 'week')?'active':''" @click="dateList('week')" href="javascript:void(0);">周榜</a>
                    <a :class="(datetype =='month')?'active':''" @click="dateList('month')" href="javascript:void(0);">月榜</a>
                </div>
            </div>
            <div class="container-body mt20">
                <div class="plane">
                    <div class="plane-header">
                        <ul>
                            <li>业绩状况</li>
                        </ul>
                    </div>
                    <div class="no-data" v-if="nodata"><span class="text">没有数据哦...</span></div>
                    <div class="plane-body clearfix" v-if="!nodata">
                        <div class="title-word-list left-body right fr">
                            <ul>
                                <li>
                                    <h1 class="color-black">{{perFormance.favCount}}</h1>
                                    <span class="color-black">收藏次数</span>
                                </li>
                                <li>
                                    <h1>{{perFormance.favUser}}</h1>
                                    <span>收藏人数</span>
                                </li>
                                <li>
                                    <h1>{{perFormance.shareCount}}</h1>
                                    <span>转发次数</span>
                                </li>
                                <li>
                                    <h1>{{perFormance.shareUser}}</h1>
                                    <span>转发人数</span>
                                </li>
                            </ul>
                        </div>
                        <div class="right-body left clearfix">
                            <div class="echart fl" id="main">
                                <div class="circle ac">
                                    <p class="fs24 fw7">{{perFormance.urlTimes}}</p>
                                </div>
                                <p class="ac">发布次数</p>
                            </div>
                            <div class="echart fl" id="main1">
                                <div class="circle cr52c ac">
                                    <p class="fs24 fw7">{{perFormance.urlNum}}</p>
                                </div>
                                <p class="ac">发布文章数</p>
                            </div>
                            <div class="column-echart big-screen fl">
                                <div class="item fl clearfix">
                                    <div class="stand-bar fl">
                                        <span class="column blue"><span class="in" :style="'height:'+avg1+'%'"></span></span>
                                        <span class="name color-black">总阅读人数</span>
                                        <span class="num color-gray">{{perFormance.readUser}}</span>
                                    </div>
                                    <div class="stand-bar fr">
                                        <span class="column blue"><span class="in" :style="'height:'+avg2+'%'"></span></span>
                                        <span class="name color-black">总阅读数</span>
                                        <span class="num color-gray">{{perFormance.readCount}}</span>
                                    </div>
                                </div>
                                <div class="item fl clearfix">
                                    <div class="stand-bar fl">
                                        <span class="column lightblue"><span class="in" :style="'height:'+avg3+'%'"></span></span>
                                        <span class="name color-black">最高阅读数</span>
                                        <span class="num color-gray">{{perFormance.maxNum}}</span>
                                    </div>
                                    <div class="stand-bar fr">
                                        <span class="column lightblue"><span class="in" :style="'height:'+avg4+'%'"></span></span>
                                        <span class="name color-black">平均阅读数</span>
                                        <span class="num color-gray">{{perFormance.avgNum}}</span>
                                    </div>
                                </div>
                                <div class="item fl clearfix">
                                    <div class="stand-bar fl">
                                        <span class="column green"><span class="in" :style="'height:'+avg5+'%'"></span></span>
                                        <span class="name color-black">原文点击数</span>
                                        <span class="num color-gray">{{perFormance.oriReadCount}}</span>
                                    </div>
                                    <div class="stand-bar fr">
                                        <span class="column green"><span class="in" :style="'height:'+avg6+'%'"></span></span>
                                        <span class="name color-black">原文点击人数</span>
                                        <span class="num color-gray">{{perFormance.oriReadUser}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="plane mt20">
                    <div class="plane-header">
                        <ul> 
                            <li :class="(Current==1?'current':'')" @click="lineChart1(1)">阅读数趋势</li>
                            <li :class="(Current==2?'current':'')" @click="lineChart1(2)">收藏趋势</li>
                            <li :class="(Current==3?'current':'')" @click="lineChart1(3)">转发趋势</li>
                            <li :class="(Current==4?'current':'')" @click="lineChart1(4)">S-WCI趋势</li>
                        </ul>
                    </div>
                    <div class="plane-body region-chart clearfix">
                        <div class="no-data" v-if="lineChartData ==''"><span class="text">没有数据哦...</span></div>
                        <lineChart id="lineEchart" :dataArray="lineChartData" v-if="lineChartData !=''" />
                    </div>
                </div>

                <div class="plane mt20">
                    <div class="plane-header">
                        <ul class="fl"> 
                            <li>业绩列表</li>
                        </ul>
                        <div class="mr20 fr">
                            <a :href="downLoadUrl" download=""><i class="icons download-icon"></i>下载数据</a>
                        </div>
                    </div>
                    
                    <div class="plane-body clearfix">
                        <table class="table ac" width="100%" border="0" cellpadding="0" cellspacing="0">
                            <colgroup>
                                <col width="">
                            </colgroup>
                            <thead>
                                <tr>
                                    <th class="ac"><span class="th-span">发布次数 / 文章数</span></th>
                                    <th class="ac"><span class="th-span up">总阅读次数 <i class="icons sort-icon"></i></span></th>
                                    <th class="ac"><span class="th-span down">最高阅读数 <i class="icons sort-icon"></i></span></th>
                                    <th class="ac"><span class="th-span">平均阅读数 <i class="icons sort-icon"></i></span></th>
                                    <th class="ac"><span class="th-span">转发次数<i class="icons sort-icon"></i></span></th>
                                    <th class="ac"><span class="th-span">收藏次数<i class="icons sort-icon"></i></span></th>
                                    <th class="ac"><span class="th-span">日期<i class="icons sort-icon"></i></span></th>
                                </tr>
                            </thead>
                            <tbody>
                                <div class="no-data" v-if="nodata1"><span class="text">没有数据哦...</span></div>
                                <tr v-for="(item,index) in mediaList" :key="index">
                                    <td>{{item.urlTimes}}/{{item.urlNum}}</td>
                                    <td>{{item.readCount}}</td>
                                    <td>{{item.maxNum}}</td>
                                    <td>{{item.avgNum}}</td>
                                    <td>{{item.shareCount}}</td>
                                    <td>{{item.favCount}}</td>
                                    <td>{{item.resDate}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
       </div>
  	</div>
</template>
<script>
import VueDatepickerLocal from 'vue-datepicker-local'
import lineChart from '@/components/echart/lineChart'
import dataAnalysisMenu from './dataAnalysisMenu.vue'
export default {
    components:{
        VueDatepickerLocal,lineChart,dataAnalysisMenu
    },
    data() {
        const time = new Date()
        //const min = new Date(2019, 5, 1)
        //const max = new Date(2019, 8, 30)
        return {
           mediaList:[],//微信列表
           wxInfo:[],//微信信息
           perFormance:[],//业绩状况
           downLoadUrl:[],//下载地址
           currentPage:1,//当前条数
           limit:10,//每页显示条数
           totalCount:0,//总条数
           currentTab:'week',//时间
           //typeCurrent:'day',//选择时间当前类型
           dateWeek:'',//周
           dateMonth:'',//月
           dateOne:'',//默认时间week month
           //dateOne2:'',//默认时间month
           timeRange:'',//默认day
            lineChartData:[],//echart图表数据
            i:0,
            readTotal:[],//阅读总数
            readMax:[],//最高阅读数
            readAvg:[],//平均阅读数
            datetime:[],//图表时间
            Current:1,
            fav:[],//收藏人数
            favCount:[],//收藏次数
            Active:false,
            selectPList:[],//选择公众号列表
            Id:'',//公众号id
            sel:'',//搜索绑定值
            datetype:'',//日期类型
            avg1:'',
            avg2:'',
            avg3:'',
            avg4:'',
            avg5:'',
            avg6:'',
            nodata:false,
            nodata1:false,


        }
    },
    mounted() {
        let that = this;
        var myDate = new Date();
        myDate.setDate(myDate.getDate() - 1);
        that.timeRange = myDate.toLocaleDateString();
        if(that.$route.query.type==undefined){
            that.currentTab = that.currentTab;
        }else{
            that.currentTab = that.$route.query.type;
        }
		if(that.$parent.mediaId==''){
			that.Id=that.Id;
		}else{
			that.Id=that.$parent.mediaId;
		}
        that.dataAjax();
        that.$nextTick(()=> {
            that.lineChartAjax();
        })
        
        
    },
    created() {
    },
    methods: {
        closeModal(){
            let that = this;
            that.Active =false;
        },
        searchButton(){//搜索公众号
            let that = this;
            that.selectPublic();
            that.Active =true;
        },
        clickPublic(id){//点击公众号
            let that = this;
            that.Id= that.$parent.mediaId = id;
            that.dataAjax();
            that.Active = !that.Active;
        },
        selectPublic(){//选择公众号
            let that = this;
            that.Active = !that.Active;
            that.$api.post('/member/accountlist',{search:that.sel,type:1},r=>{
                that.$parent.returnCode(r,function(){
                    that.selectPList = r.data.list;
                })
            })


        },
        lineChart1(type){//线性图表
            let that = this;
            that.Current = type;
            that.lineChartAjax(type);
        },
        lineChartAjax(type){//
            let that = this;
            type = that.Current;
            if(type == 1){
                let newData = {
                    "dataName":['阅读总数','最高阅读数','平均阅读数'],
                    "阅读总数":that.readTotal,
                    "最高阅读数":that.readMax,
                    "平均阅读数":that.readAvg,
                    "datetime":that.datetime
                };
                that.lineChartData = newData;
            }else if(type == 2){
                let newData = {
                    "dataName":['收藏次数','收藏人数'],
                    "收藏次数":that.favCount,
                    "收藏人数":that.fav,
                    "datetime":that.datetime
                };
                that.lineChartData = newData;
            }else if(type == 3){
                let newData = {
                    "dataName":['转发次数','转发人数'],
                    "转发次数":that.shareCount,
                    "转发人数":that.share,
                    "datetime":that.datetime
                };
                that.lineChartData = newData;
            }else if(type == 4){
                let newData = {
                    "dataName":['S-WCI趋势'],
                    "S-WCI趋势":that.wci,
                    "datetime":that.datetime
                };
                that.lineChartData = newData;
            }
            
        },
        dateClick(type1){//点击时间下拉
            let that = this;
            that.dateOne = type1;
            that.$router.push({
                path: '/wxdataAnalysis',
                query: {
                    type1: type1
                }
            });
            that.dateOne = that.$route.query.type1;
            that.dataAjax();

        },
        dateList(type){//点击切换 日周月榜
            let that = this;
            that.currentTab = type;
            if(type=='day'){
               that.dateOne = that.timeRange;
               console.log();
            }else if(type=='week'){
                that.dateOne = that.dateWeek[0]
            }else if(type=='month'){
                that.dateOne = that.dateMonth[0]
            }
            that.dataAjax();
            that.$router.push({
                path: '/wxdataAnalysis?type1='+that.dateOne,
                query: {
                    type: that.currentTab
                }
            });
        },
        disabledDate(time,format){
            let that = this;
            if(time.getTime() > new Date().getTime()) return true;
        },
        selectedDate(date) {//点击日榜时间确定
            let that = this;
            that.dateOne = that.timeRange = that.$utils.dateConversion(that.timeRange,0);
            that.dataAjax();
        },
        dataAjax(){//微信列表
            let that = this;
            let url = '';
            that.$parent.loadModal(true,'正在加载...');
            that.$api.post('/datacube/wxperformance',{dateType:that.currentTab,date:that.dateOne,id:that.Id},r=>{
                that.$parent.showLoad = false;
                that.$parent.returnCode(r,function(){
                    
                that.mediaList=r.data.list;
                that.wxInfo = r.data.info;
                that.perFormance = r.data.performance;
                that.downLoadUrl = r.data.downloadUrl;    
                that.dateWeek = r.data.week;  
                that.dateWeek[0] = r.data.week[0];  
                that.dateMonth = r.data.month;
                that.datetype = r.data.type;
                console.log(that.datetype);
                that.readTotal = r.data.readTotal;
                that.readMax = r.data.readMax;
                that.readAvg = r.data.readAvg;
                that.datetime = r.data.date;
                that.wci = r.data.wci;
                that.favCount = r.data.favCount;
                that.fav = r.data.fav;
                that.shareCount = r.data.shareCount;
                that.share = r.data.share;
                that.i = r.data.readTotal.length;
                    if(that.$route.query.type1 == undefined){
                        that.dateOne = that.dateWeek[0]
                    }else{
                        that.dateOne = that.$route.query.type1;
                    }
                that.lineChartAjax();
                    if(that.mediaList.length<=0){
                        that.nodata1 = true;
                    }else{
                        that.nodata1 = false;
                    }
                    if(that.perFormance.length<=0){
                        that.nodata = true;
                    }else{
                        that.nodata = false;
                    }
                    if(r.data.performance.readCount==0){
                        that.avg1 = that.avg2 = that.avg3 = that.avg4 = that.avg5 =that.avg6 =0;
                    }else{
                        that.avg1 = r.data.performance.readUser/r.data.performance.readCount*100>100?'100':r.data.performance.readUser/r.data.performance.readCount*100;
                        that.avg2 = r.data.performance.readCount/r.data.performance.readCount*100>100?'100':r.data.performance.readCount/r.data.performance.readCount*100;
                        that.avg3 = r.data.performance.maxNum/r.data.performance.readCount*100>100?'100':r.data.performance.maxNum/r.data.performance.readCount*100;
                        that.avg4 = r.data.performance.avgNum/r.data.performance.readCount*100>100?'100':r.data.performance.avgNum/r.data.performance.readCount*100;
                        that.avg5 = r.data.performance.oriReadCount/r.data.performance.readCount*100>100?'100':r.data.performance.oriReadCount/r.data.performance.readCount*100;
                        that.avg6 = r.data.performance.oriReadUser/r.data.performance.readCount*100>100?'100':r.data.performance.oriReadUser/r.data.performance.readCount*100;
                    }
                })
            })
       }
       
	}
}
</script>



// WEBPACK FOOTER //
// src/page/dataAnalysis/dataAnalysis.vue